import { fontColorForBackground } from '../utils/colors'
import { listColors } from '../utils/bike-schema'
import { formatCurrencyAlwaysSign } from '../utils/money'
import { t } from '../utils/i18n'

const ListSpecialRals = ({
  onSelect,
  activeRal,
  currencyCode,
  priceDiffForRal
}) => (
  <div>
    <div data-ral="S" className="velorbis-customizer-ral-picker-color head">
      {t('ral_color_category_S')}:
    </div>
    {listColors().map(({ ral, hex, name }) => {
      const priceDiff = priceDiffForRal ? priceDiffForRal(ral) : 0
      if (ral < 1000) {
        return (
          <div
            key={ral}
            className="velorbis-customizer-ral-picker-color"
            style={{
              backgroundColor: hex,
              color: fontColorForBackground(hex)
            }}
            data-ral={`S${ral}`}
            onClick={() => onSelect(ral)}
          >
            <div className="velorbis-customizer-ral-picker-color-name">
              {name}
              {priceDiff !== 0 && (
                <span className="velorbis-customizer-ral-picker-color-price">
                  {' '}
                  {formatCurrencyAlwaysSign(priceDiff, currencyCode)}
                </span>
              )}
              {activeRal == ral && (
                <div className="velorbis-customizer-ral-picker-color-selected">
                  {t('selected')}
                </div>
              )}
            </div>
          </div>
        )
      }
    })}
    <div className="velorbis-customizer-ral-picker-separator__with-spacing" />
  </div>
)
export default ListSpecialRals
